import cx from 'classnames';
import React, { useCallback } from 'react';
import SVG from 'react-inlinesvg';

import { SvgIconProps } from './types';

const SvgIcon: React.FC<SvgIconProps> = ({
  className,
  src,
  title,
  width = 24,
  height = 'auto',
  color = 'currentColor', // currentColor is defined in SVG standard
  onClick,
  metadata = {
    'data-automation-id': 'svg-icon',
  },
}) => {
  const svgProcessor = useCallback(
    (svgCode) => {
      const dataAutomationId = metadata['data-automation-id'];
      if (color !== 'currentColor') {
        svgCode = svgCode.replace(/fill=".*?"/g, `fill="${color}"`);
      }

      return svgCode.replace(/xmlns="(.*?)"/g, `xmlns="$1" data-automation-id="${dataAutomationId}"`);
    },
    [color, metadata],
  );

  return (
    <SVG
      src={src}
      width={width}
      height={height}
      title={title}
      onClick={onClick}
      preProcessor={svgProcessor}
      className={cx('svg-icon-wrapper', className)}
    />
  );
};

SvgIcon.displayName = 'SvgIcon';

export default SvgIcon;
